/**
 * 加载组件
 */

//  加载VUE
import Vue from 'vue'

//  拷贝组件
import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

//  图片裁剪
import VueCropper from 'vue-cropper'
Vue.use(VueCropper)

/** 数据本地缓存 */
import minCache from '@/utils/minCache.js'
Vue.use(minCache, {timeout: 7200});     //  注册缓存器

/** 自定义工具库 */
import util from '@/utils/util.js'
Vue.prototype.$util = util

/** 登录用户函数库 */
import user from '@/utils/user.js'
Vue.prototype.$user = user

/** 普通操作类库 */
import common from '@/utils/common.js'
Vue.prototype.$common = common

//  登录弹框层
import LoginModal from '@/components/LoginModal/index.js'
Vue.prototype.$LoginModal = LoginModal

//  复制弹框
import ClipboardIcon from '@/components/Common/ClipboardIcon'
Vue.use(ClipboardIcon)

//  加载SVG ICON
import '@/icons'

//  自定义图标
import '@/assets/iconfont/iconfont.css';

//  加载自定义的通用CSS
import '@/assets/css/index.css';


